/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "@angular/core";
import { User } from "./user.model";

interface AppStorage {
    token: string;
    userInfo: User;
}

@Injectable()
export class UserService {
    private _appStorage: AppStorage | undefined;

    get appStorage(): AppStorage {
        if (!this._appStorage) {
            const appToken: any = localStorage.getItem("auth_app_token");
            if (appToken) {
                this._appStorage = JSON.parse(appToken);
            }
        }
        return this._appStorage as AppStorage;
    }

    get user(): User {
        return this.appStorage?.userInfo || null;
    }

    get token(): string {
        return sessionStorage.getItem("access_token") || "";
    }

    get role(): string {
        return this.user?.role;
    }
    // TODO: check if necessary and refactor (see SCRIVA because use SHIB)
    saveUser(result: any): void {
        const storageAuthAppToken = JSON.parse(localStorage.getItem("auth_app_token") || "");
        this._appStorage = {
            userInfo: result.getResponse().body,
            ...storageAuthAppToken,
        };

        localStorage.setItem("auth_app_token", JSON.stringify(this._appStorage));
    }
}
